export default __webpack_public_path__ + "static/media/5_7.59778149.jpg";